import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles({
  dialogContainer: { minHeight: '40%' },
  dialogContent: { minWidth: 500 },
})

export { useStyles }
